<ng-container *ngIf="data$ | async">
  <ng-container *ngIf="showLabel">
    <miq-record-detail-label [column]="config">
      <miq-pin-favorite class="extra-icons" [column]="config"></miq-pin-favorite>
    </miq-record-detail-label>
  </ng-container>
  <div class="flex-grid">
    <!-- DEFAULT SINGLE INPUT -->
    <miqControlWithRuleEngine
      [formCtrl]="form"
      [dataCtrl]="control"
      [(config)]="config"
      [hidden]="config.hidden"
      class="col"
    >
      <miq-input-control [formControl]="control" [(column)]="config"> </miq-input-control>
    </miqControlWithRuleEngine>
    <!-- RELATED INPUT -->

    <ng-container
      *ngTemplateOutlet="
        relatedColumn;
        context: { columns: config | relatedConfigs: config.componentConfig?.targetRelation }
      "
    ></ng-container>
    <ng-template #relatedColumn let-columns="columns">
      <ng-container *ngFor="let col of columns; let i = index">
        <miqControlWithRuleEngine
          [formCtrl]="form"
          [dataCtrl]="relatedControls[columns[i].columnId]"
          [(config)]="columns[i]"
          [hidden]="columns[i].hidden"
          class="col"
        >
          <miq-input-control
            [id]="'columns' + columns[i]?.columnId"
            [formControl]="relatedControls[columns[i].columnId]"
            [(column)]="columns[i]"
          >
          </miq-input-control>
        </miqControlWithRuleEngine>
      </ng-container>
    </ng-template>

    <!-- render input icons if configured -->
    <span
      *ngFor="let inputIcon of config.inputIcons"
      [miqInputIconHandler]="inputIcon"
      [control]="control"
      class="extra-icons"
    >
    </span>
  </div>

  <!-- 
    Composite Control Errors
    These can be configured with a validation function returning an error like:
    const CompositeMessageValidator = () => ({ message: 'Custom error message', type: 'error' })
  -->
  <ng-container *ngIf="control.errors">
    <div *ngFor="let ctrlError of control.errors | keyvalue">
      <miq-input-message
        *ngIf="ctrlError.value?.message"
        [message]="ctrlError.value.message"
        [type]="ctrlError.value.type"
        [show]="ctrlError.value.show"
      >
      </miq-input-message>
    </div>
  </ng-container>

  <!-- Configured messages for the component -->
  <ng-container *ngIf="config.inputMessages?.length">
    <div *ngFor="let inputMsg of config.inputMessages">
      <miq-input-message [message]="inputMsg.message" [type]="inputMsg.type" [show]="inputMsg.show">
      </miq-input-message>
    </div>
  </ng-container>
</ng-container>
